import { useProps } from '../App';
import { Box, Button, Container, Drawer, FormControlLabel, IconButton, MenuItem, Switch, TextField, Typography } from '@mui/material';
import Grid from "@mui/material/Grid";
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import { useState, useLayoutEffect, useEffect } from 'react';
import client from '../utils/Client'
import { JWT_TOKEN, JWT_TOKEN_REFRESH } from "../utils/Consts";
import ClearIcon from '@mui/icons-material/Clear';

function Filter({ children }) {
    return (
        <Grid item xs={12} sm={8} lg={6}>
            {children}
        </Grid>
    );
}

export function getParams({ isAdmin, isPending, isVideoOnly, isNsfw, pageNum, searchParams }) {

    const params = {};

    if (searchParams !== '') {
        params.artist_social_id = searchParams;
    }
    if (!isAdmin) {
        params.approved = true;
    }
    if (isAdmin && !isPending) {
        params.approved = true;
    }
    if (isAdmin && isPending) {
        params.approved = false;
    }
    if (isVideoOnly) {
        params.mime = "mp4";
    }
    if (isNsfw === "both" && params.nsfw) {
        delete params.nsfw
    }
    if (isNsfw === "false") {
        params.nsfw = false;
    }
    if (isNsfw === "true") {
        params.nsfw = true;
    }
    params.page = pageNum;

    return new URLSearchParams(params);

}

const isUUID = (str) => {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidRegex.test(str);
};

export const handleLoadNext = ({ itemsData, setItemData, pageNum, setPageNum, hasMore, setHasMore, isVideoOnly, isNsfw, isAdmin, loading, setLoading, isPending, searchParams, smartSearchParams }) => {

    if (!loading) {
        if (!smartSearchParams) {
            setLoading(true);
            client.get(`/api/media/?${getParams({ isAdmin, isPending, isVideoOnly, isNsfw, pageNum, searchParams })}`)
                .then(({ data }) => {
                    setLoading(false);
                    setHasMore(data['next'] ? true : false);
                    // console.log(itemsData.concat(data['results']));
                    setItemData(itemsData.concat(data['results']));
                    setPageNum(pageNum + 1);
                })
                .catch(error => {
                    setLoading(false);
                    // 检查是否是token过期错误(401)
                    if (error.response && error.response.status === 403) {
                        // token过期时不设置hasMore为false
                        // 清除本地token
                        localStorage.removeItem(JWT_TOKEN_REFRESH);
                        localStorage.removeItem(JWT_TOKEN);
                        // 可以触发重新登录流程
                        window.location.reload();
                    } else {
                        // 其他错误才设置hasMore为false
                        setHasMore(false);
                    }
                    console.error('Fetch error:', error);
                })
                .finally(() => setLoading(false))
        } else if (smartSearchParams) {
            setLoading(true);

            // 根据 smartSearchParams 是否为 UUID 来构建请求体
            const requestBody = isUUID(smartSearchParams)
                ? { queryAssetId: smartSearchParams, page: pageNum }
                : { query: smartSearchParams, page: pageNum };

            client.post(
                `/api/search/?${getParams({ isAdmin, isPending, isVideoOnly, isNsfw, pageNum, searchParams })}`,
                requestBody
            )
                .then(({ data }) => {
                    setLoading(false);
                    setHasMore(data ? true : false);
                    // console.log(itemsData.concat(data));
                    setItemData(itemsData.concat(data));
                    setPageNum(pageNum + 1);
                    // console.log('pagenum: ', pageNum)
                })
                .catch(error => {
                    setLoading(false);
                    // 检查是否是token过期错误(401)
                    if (error.response && error.response.status === 403) {
                        // token过期时不设置hasMore为false
                        // 清除本地token
                        localStorage.removeItem(JWT_TOKEN_REFRESH);
                        localStorage.removeItem(JWT_TOKEN);
                        // 可以触发重新登录流程
                        window.location.reload();
                    } else {
                        // 其他错误才设置hasMore为false
                        setHasMore(false);
                    }
                    console.error('Fetch error:', error);
                })
                .finally(() => setLoading(false))
        }
    }
}

export default function ImageFilter() {

    const {
        userInfo,
        isPending, setIsPending,
        isReview, setIsReview,
        isVideoOnly, setIsVideoOnly,
        isAutoplay, setIsAutoplay,
        isNsfw, setIsNsfw,
        filterOpen, setFilterOpen,
        searchParams, setSearchParams,
        smartSearchParams, setSmartSearchParams,
    } = useProps();
    const isAdmin = !!userInfo?.is_staff

    const toggleSettingsDrawer = (newOpen) => () => {
        setFilterOpen(newOpen);
    };

    const [temporary, setTemporary] = useState('');
    const [temporary1, setTemporary1] = useState('');

    // 当外部的 searchParams/smartSearchParams 变化时同步到本地输入状态
    useEffect(() => {
        setTemporary(searchParams ?? '');
    }, [searchParams]);

    useEffect(() => {
        setTemporary1(smartSearchParams ?? '');
    }, [smartSearchParams]);

    useLayoutEffect(() => {
        localStorage.setItem("userVideoOnly", isVideoOnly);
        localStorage.setItem("userAutoplay", isAutoplay);
        localStorage.setItem("userNsfw", isNsfw);
        // console.log("SET userNsfw: ", isNsfw);
    }, [isVideoOnly, isAutoplay, isNsfw])

    // 共用函数：关闭抽屉并滚动到顶部
    const closeDrawerAndScroll = () => {
        setFilterOpen(false);
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);
    };

    return (

        <Drawer anchor='top' open={filterOpen} onClose={toggleSettingsDrawer(false)}>
            <Container maxWidth="lg" sx={{ padding: 4, paddingBottom: 0.5 }}>
                <Typography variant="h6">Filter</Typography>
                <br />
                <Grid container columns={{ xs: 8, sm: 16, md: 24 }} rowSpacing={1} columnSpacing={4}>

                    {isAdmin ?
                        <>
                            <Filter>
                                <FormControlLabel
                                    control={<Switch id="Pending" checked={isPending} onChange={() => { setIsPending(!isPending) }} />}
                                    label="Pending"
                                />
                            </Filter>
                            <Filter>
                                <FormControlLabel
                                    control={<Switch id="Review" checked={isReview} onChange={() => { setIsReview(!isReview) }} />}
                                    label="Review"
                                />
                            </Filter>
                            <Filter>
                                <FormControlLabel
                                    control={<Switch id="Video Only" checked={isVideoOnly} onChange={() => {
                                        setIsVideoOnly(!isVideoOnly);
                                        // setIsAutoplay(false);
                                    }} />}
                                    label={
                                        <>
                                            <Typography>Video Only</Typography>
                                            <Typography color='info' variant="caption" sx={{ display: { xs: 'none', sm: 'block' } }}>
                                                Bandwidth consume warning!
                                            </Typography>
                                        </>
                                    }
                                />
                            </Filter>
                            <Filter>
                                <FormControlLabel
                                    control={<Switch id="Autoplay" checked={isAutoplay} onChange={() => { setIsAutoplay(!isAutoplay) }} />}
                                    label={
                                        <>
                                            <Typography>Autoplay</Typography>
                                            <Typography color='info' variant="caption" sx={{ display: { xs: 'none', sm: 'block' } }}>
                                                Video is muted by default.
                                            </Typography>
                                        </>
                                    }
                                />
                            </Filter>
                        </>
                        :
                        <>
                            <Filter>
                                <FormControlLabel
                                    control={<Switch id="Video Only" checked={isVideoOnly} onChange={() => {
                                        setIsVideoOnly(!isVideoOnly);
                                        // setIsAutoplay(false);
                                    }} />}
                                    label={
                                        <>
                                            <Typography>Video Only</Typography>
                                            <Typography color='info' variant="caption" sx={{ display: { xs: 'none', sm: 'block' } }}>
                                                Bandwidth consume warning!
                                            </Typography>
                                        </>
                                    }
                                />
                            </Filter>
                            <Filter>
                                <FormControlLabel
                                    control={<Switch id="Autoplay" checked={isAutoplay} onChange={() => { setIsAutoplay(!isAutoplay) }} />}
                                    label={
                                        <>
                                            <Typography>Autoplay</Typography>
                                            <Typography color='info' variant="caption" sx={{ display: { xs: 'none', sm: 'block' } }}>
                                                Video is muted by default.
                                            </Typography>
                                        </>
                                    }
                                />
                            </Filter>
                        </>
                    }

                    <Filter>
                        <TextField
                            select
                            fullWidth
                            label="NSFW?"
                            variant="standard"
                            margin="none"
                            value={isNsfw}
                            onChange={(event) => setIsNsfw(event.target.value)}
                        >
                            {[
                                { value: 'true', title: "NSFW" },
                                { value: 'false', title: "SFW" },
                                { value: 'both', title: "BOTH" },
                            ].map(({ value, title }) => (
                                <MenuItem id={title} key={value} value={value}>
                                    {title}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Filter>
                    <Filter>
                        <Box
                            component="form"
                            id='search artist'
                            noValidate
                            autoComplete="off"
                            onSubmit={(e) => {
                                e.preventDefault();
                                closeDrawerAndScroll();
                                setTimeout(() => {
                                    setSearchParams(temporary);
                                }, 300);
                            }}
                        >
                            <TextField
                                fullWidth
                                id="outlined-basic"
                                margin="none"
                                label="Search artist"
                                variant="standard"
                                value={temporary}
                                helperText={
                                    <Typography color='info' variant='caption'>
                                        e.g. spommmm
                                    </Typography>
                                }
                                onChange={(event) => setTemporary(event.target.value)}
                            />
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={
                                    () => {
                                        closeDrawerAndScroll();
                                        setTimeout(() => {
                                            setSearchParams('');
                                            setTemporary('');
                                        }, 750);
                                    }
                                }
                                endIcon={<ClearIcon />}
                                disabled={searchParams ? false : true}
                            >
                                Reset Search
                            </Button>
                        </Box>
                    </Filter>

                    <Filter>
                        <Box
                            component="form"
                            id='smart search'
                            noValidate
                            autoComplete="off"
                            onSubmit={(e) => {
                                e.preventDefault();
                                closeDrawerAndScroll();
                                setTimeout(() => {
                                    setSmartSearchParams(temporary1);
                                }, 300);
                            }}
                        >
                            <TextField
                                fullWidth
                                id="outlined-basic"
                                margin="none"
                                label="Smart search"
                                variant="standard"
                                value={temporary1}
                                helperText={
                                    <Typography color='info' variant='caption'>
                                        e.g. white cat with glasses
                                    </Typography>
                                }
                                onChange={(event) => {
                                    setTemporary1(event.target.value);
                                }}
                            />
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={
                                    () => {
                                        closeDrawerAndScroll();
                                        setTimeout(() => {
                                            setSmartSearchParams('');
                                            setTemporary1('');
                                        }, 750);
                                    }
                                }
                                endIcon={<ClearIcon />}
                                disabled={smartSearchParams ? false : true}
                            >
                                Reset Search
                            </Button>
                        </Box>
                    </Filter>

                </Grid>
            </Container>

            <IconButton sx={{ alignSelf: 'center' }} onClick={toggleSettingsDrawer(false)} >
                <KeyboardArrowUpRoundedIcon />
            </IconButton>

        </Drawer>

    )

}